import { observer } from 'mobx-react'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { IconNotification } from '@avantstay/backoffice-vectors'

import { operationsNotificationStore } from '../../OperationsNotificationStore'
import * as S from './NotificationButton.styles'

const _NotificationButton = () => {
  const location = useLocation()
  const {
    setShowNotificationModal,
    showNotificationModal,
    hasUnreadNotifications,
    notifications,
    refreshOnNavigation,
  } = operationsNotificationStore

  useEffect(() => {
    refreshOnNavigation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search])

  useEffect(() => {
    if (showNotificationModal) {
      notifications.silentRefresh()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showNotificationModal])

  return (
    <S.NotificationButton
      type="button"
      className="click-outside-excluded"
      hasNotifications={hasUnreadNotifications}
      onClick={() => setShowNotificationModal(!showNotificationModal)}
    >
      <IconNotification />
    </S.NotificationButton>
  )
}

export const NotificationButton = observer(_NotificationButton)
